import { defineAction } from '~/prix'
import { z } from 'zod'
import expression from '~/prix/types/expression'
import { enumerated } from '~/prix/types/enumerated'
import heavyMachineryListAction from './heavyMachineryList.action.json' with { type: 'json' }
import { heavyMachineryObject } from '../heavyMachineryObject'

export const heavyMachineryExpression = expression(heavyMachineryObject.shape)

const heavyMachineryListDefinition = defineAction({
  ...heavyMachineryListAction,

  input: z.object({
    filter: heavyMachineryExpression.nullish(),
    limit: z.number().min(1).max(5000).nullish(),
    offset: z.number().nullish(),
    orderBy: enumerated({
      createdAt: 'Data de criação',
      updatedAt: 'Data de atualização',
      id: 'Identificador',
      code: 'Código',
      title: 'Título',
      type: 'Tipo',
      patrimonyNumber: 'Número de patrimônio',
      year: 'Ano',
      hourPrice: 'Preço por hora',
    }).nullish(),
    order: enumerated({
      ascending: 'Ascendente',
      descending: 'Descendente',
    }).nullish(),
    includeDeleted: z.boolean().nullish(),
  }),
  output: z.object({
    items: z.array(heavyMachineryObject),
    count: z.number(),
  }),
})

export default heavyMachineryListDefinition
